var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartDetailPageOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,17.5H5V2.5H15v15m1.5.5V2a1,1,0,0,0-1-1H4.5a1,1,0,0,0-1,1V18a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 6,
    height: 1.38,
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 6,
    height: 1.38,
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 4,
    height: 1.38,
    rx: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartDetailPageOutlined);
export default __webpack_public_path__ + "static/media/smartDetailPageOutlined.fb932c3b3bbe2d9ca2fecedf91e034a1.svg";
export { ForwardRef as ReactComponent };